module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.list), function(item, key) {
    return _c('div', [_c('p', [_vm._v(_vm._s(item.title))])])
  }), _vm._v(" "), _c('hrms-infinite-loading', {
    ref: "infiniteLoading",
    on: {
      "infinite": _vm.onInfinite
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("\n      There is no more Hacker News :(\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19e37b7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueInfinite/component.vue
// module id = 3602
// module chunks = 1